document.querySelectorAll('.mainGrid-swiper').forEach((slider) => {
  new Swiper(slider, {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,

    pagination: {
      el: slider.querySelector('.swiper-pagination'),
      clickable: true,
    },
  });
});

 class CommonAccordion extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {

    this.items = this.querySelectorAll('[accordion-item]');

    this.items.forEach((item, index) => {

      const trigger = item.querySelector('[accordion-trigger]');

      if (!trigger) return;

      trigger.addEventListener('click', () => {

        if (item.classList.contains('active')) {

          this.closeAccordion(item);

        } else {

          this.items.forEach((accordionItem) => {
            this.closeAccordion(accordionItem);
          });

          this.openAccordion(item);

        }

      });

      if (
        this.hasAttribute('open-first-accordion') &&
        index === 0
      ) {
        this.openAccordion(item);
      }

    });

  }

  openAccordion(item) {

    const content = item.querySelector('[accordion-content]');

    if (!content) return;

    item.classList.add('active');

    content.style.maxHeight = content.scrollHeight + 'px';

  }

  closeAccordion(item) {

    const content = item.querySelector('[accordion-content]');

    if (!content) return;

    item.classList.remove('active');

    content.style.maxHeight = null;

  }

}

if (!customElements.get('common-accordion')) {
  customElements.define('common-accordion', CommonAccordion);
}

// Footer height
function updateFooterHeights() {
  const footer = document.querySelector('.routine-footer'); 
  
  // Early exit if no header - nothing to do
  if (!(footer instanceof HTMLElement)) return;

  // Calculate initial heights
  const footerHeight = footer.offsetHeight;  
  document.body.style.setProperty('--footer-height', `${footerHeight}px`); 
}
updateFooterHeights();
window.addEventListener('resize', updateFooterHeights);

// Header drawer cart button
document.querySelector('.header-drawer-cart-icon')?.addEventListener('click', function (e) {
  e.preventDefault();
  document.querySelector('cart-drawer-component').open();
  document.querySelector('header-drawer').close()
});

class CustomQuickadd extends HTMLElement {
  constructor() {
    super();

    this.product = JSON.parse(
      this.querySelector('script[type="application/json"]').textContent
    );

    this.selectedVariant = null;
  }

  connectedCallback() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => this.onVariantChange());
    });

    this.onVariantChange();
  }

  getSelectedOptions() {
    return this.product.options.map((optionName, index) => {
      return this.querySelector(
        `input[name="option${index + 1}-${this.product.id}"]:checked`
      )?.value;
    });
  }

  updateOptionAvailability() {
    this.product.options.forEach((optionName, optionIndex) => {
      const inputs = this.querySelectorAll(`[name="option${optionIndex + 1}-${this.product.id}"]`);

      inputs.forEach((input) => {
        const testOptions = [...this.getSelectedOptions()];
        testOptions[optionIndex] = input.value;

        const availableVariant = this.product.variants.find((variant) => variant.available && variant.options.every((option, index) => option === testOptions[index]));

        input.disabled = !availableVariant;

        const label = this.querySelector(`label[for="${input.id}"]`);

        label?.classList.toggle('disabled',!availableVariant);
      });
    });
  }

  onVariantChange() {
    const selectedOptions = this.getSelectedOptions();

    this.selectedVariant = this.product.variants.find((variant) => {
      return variant.options.every((option, index) => {
        return option === selectedOptions[index];
      });
    });

    this.updateOptionAvailability();

    const variantInput = this.querySelector('input[name="id"]');
    const addToCartButton = this.querySelector('button[name="add"]');

    if ( this.selectedVariant && this.selectedVariant.available) {
      variantInput.value = this.selectedVariant.id;
      addToCartButton.click();
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = false;
      });

    }
  }
}

customElements.define('custom-quickadd', CustomQuickadd);